export const SIGNUP_STRINGS = {
  en: {
    INVITATION: [
      'has invited you to try out a free workout using Bruce Studios ✌️ Create an account with the code',
      'and lets go!',
    ],
    STEP: 'Step 1 of 2',
    META_TITLE: 'Signup',
    TITLE: 'Create an account',
    ERROR_USER_ALREADY_EXISTS: 'Already registered',
    GIFT_CARD_TEXT:
      'We will send a link to your gift card and receipt of your purchase to the email you enter below.',
  },
  sv: {
    INVITATION: [
      'har bjudit in dig att testa en gratis träning i Bruce Studios ✌️ Skapa konto med koden',
      'så kör vi!',
    ],
    STEP: 'Steg 1 av 2',
    META_TITLE: 'Skapa konto',
    TITLE: 'Skapa ett konto',
    ERROR_USER_ALREADY_EXISTS: 'Redan registrerad',
    GIFT_CARD_TEXT:
      'Vi skickar en länk till ditt presentkort samt kvitto på ditt köp till e-posten du anger nedan.',
  },
  nb: {
    INVITATION: [
      'har invitert deg til å prøve en gratis treningsøkt med Bruce Studios ✌️ Opprett en konto med koden',
      'og la gå!',
    ],
    STEP: 'Steg 1 av 2',
    META_TITLE: 'Opprett konto',
    TITLE: 'Opprett konto',
    ERROR_USER_ALREADY_EXISTS: 'Allerede registrert',
    GIFT_CARD_TEXT:
      'Vi sender en lenke til gavekortet ditt og kvittering for kjøpet til e-posten du skriver inn nedenfor.',
  },
  da: {
    INVITATION: [
      'har inviteret dig til at prøve en gratis træning via Bruce Studios ✌️ Opret en konto med koden',
      'for at komme i gang!',
    ],
    STEP: 'Step 1 af 2',
    META_TITLE: 'Opret konto',
    TITLE: 'Opret en konto',
    ERROR_USER_ALREADY_EXISTS: 'Allerede registreret',
    GIFT_CARD_TEXT:
      'Vi sender et link til dit gavekort og kvittering for dit køb til den e-mail, du indtaster nedenfor.',
  },
} as const
